import {decodeHtmlEntities as decode} from '@web/helpers/htmlEntities'

import {Element, Item} from '../apis'

export const elementMapper = (elements: Maybe<Element[]>) => {
    return (
        elements?.map((element) => {
            return {
                id: element.id,
                names: element.names,
                valueIds: element.valueIds,
                texts: element.texts,
                elementType: element.type,
            }
        }) ?? null
    )
}

export const productItemsMapper = (items: Item[]) => {
    return items.map((item) => {
        return {
            productOrderNo: item.productOrderNo,
            productName: item.productName ?? undefined,
            productNo: item.productNo ?? undefined,
            price: item.price,
            initProductPayAmount: item.initProductPayAmount ?? undefined,
            productClassType: item.productClassType,
            quantity: item.quantity,
            initOrderQuantity: item.initOrderQuantity ?? undefined,
            optionContents: item.optionContents ?? '',
            deliveryMemo: decode(item.deliveryMemo ?? ''),
            templateMemo: item.templateMemo,
            elements: elementMapper(item.elements),
        }
    })
}
